import { EntityType, EntityTypeSupportingCard } from "@mapmycustomers/shared/types/entity";

import RelationshipType from "@app/component/preview/enum/RelationshipType";
import CompanyFieldName from "@app/util/fieldModel/CompanyFieldName";
import getFieldModelByEntityType from "@app/util/fieldModel/getByEntityType";

// Only parent/child company links are gated: every other association can also be made from the
// related record's side, so hiding its "add" control would add steps without preventing anything.
const gatedCompanyRelationshipTypes = new Set<RelationshipType>([
  RelationshipType.CHILD_COMPANY,
  RelationshipType.PARENT_COMPANY,
]);

// Whether the user may add a related record of the given relationship type. Linking a parent or
// child company writes the Parent Company field, so that link respects the field's edit access.
const isRelationshipFieldEditable = (
  entityType: EntityTypeSupportingCard,
  relationshipType: RelationshipType
): boolean =>
  entityType !== EntityType.COMPANY ||
  !gatedCompanyRelationshipTypes.has(relationshipType) ||
  // Missing field or missing schema => no restriction; default to editable.
  getFieldModelByEntityType(EntityType.COMPANY).getByName(CompanyFieldName.PARENT_COMPANY)
    ?.isEditable !== false;

export default isRelationshipFieldEditable;
